import { render, staticRenderFns } from "./ActivityIndieStory.vue?vue&type=template&id=f5c3d12e&scoped=true&"
import script from "./ActivityIndieStory.vue?vue&type=script&lang=js&"
export * from "./ActivityIndieStory.vue?vue&type=script&lang=js&"
import style0 from "./ActivityIndieStory.vue?vue&type=style&index=0&id=f5c3d12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c3d12e",
  null
  
)

export default component.exports